import * as React from 'react';
import { Text } from 'components';
import { ListingDoc } from '@bb/domain/dist/schemas';

type IncludedAndExcludedListProps = {
  freehold: ListingDoc['freehold'];
};

const INCLUDED_EXCLUDED = {
  all_inclusive: 'All Inclusive', // eslint-disable-line
  heat: 'Heat Included',
  hydro: 'Hydro Included',
  water: 'Water Included',
  gas: 'Gas Included',
  cable: 'Cable T.V. Included',
  phone: 'Phone Included',
  cac: 'CAC Included',
};

type IncludedExcludedEntries = [keyof typeof INCLUDED_EXCLUDED, 'Yes' | 'No'][];

const IncludedAndExcludedList: React.FunctionComponent<
  IncludedAndExcludedListProps
> = ({ freehold }) => (
    <div className="row">
      <div className="col-md-4">
        <div>
          <Text strong>Included/Excluded:</Text>
        </div>
        {(
          Object.entries(freehold.included_excluded) as IncludedExcludedEntries
        ).map(([key, val], index) => (
          <div key={index}>
            <Text strong>{INCLUDED_EXCLUDED[key]}: </Text>
            <Text type="secondary"> {val}</Text>
          </div>
        ))}
      </div>
    </div>
  );

export default IncludedAndExcludedList;
